import React from "react";

export default function SQLServer_TAN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_TAN</h1>
      <p>This is the SQLServer_TAN component generated from the SQL JSON.</p>
    </div>
  );
}
